import React, { useEffect, useState } from 'react';
import { Icon } from '@iconify/react';
import { getEnrichedDailyBlogPost } from '../../engines/cryptoNewsEngine';
import ContentShareMenu from '../ContentShareMenu/ContentShareMenu';

function DailyBlogPost() {
    const [post, setPost] = useState(null);

    useEffect(() => {
        let active = true;

        getEnrichedDailyBlogPost()
            .then((result) => {
                if (active) setPost(result);
            })
            .catch(() => {
                if (active) {
                    import('../../engines/cryptoNewsEngine').then(({ getDailyBlogPost }) => {
                        setPost(getDailyBlogPost());
                    });
                }
            });

        return () => {
            active = false;
        };
    }, []);

    if (!post) {
        return (
            <section className="home-blog-section" aria-label="Loading daily market blog">
                <div className="daily-blog-card daily-blog-card--loading">
                    <div className="daily-blog-skeleton daily-blog-skeleton--image" />
                    <div className="daily-blog-skeleton-body">
                        <div className="daily-blog-skeleton daily-blog-skeleton--line" />
                        <div className="daily-blog-skeleton daily-blog-skeleton--line short" />
                        <div className="daily-blog-skeleton daily-blog-skeleton--line" />
                    </div>
                </div>
            </section>
        );
    }

    const shareText = post.excerpt || post.paragraphs?.[0] || post.title;

    return (
        <section id="daily-market-blog" className="home-blog-section" aria-label="Daily cryptocurrency market blog">
            <article className="daily-blog-card">
                <div className="daily-blog-media">
                    <img
                        src={post.image}
                        alt=""
                        className="daily-blog-image"
                        loading="lazy"
                    />
                    <span className="daily-blog-category">{post.category}</span>
                </div>

                <div className="daily-blog-content">
                    <header className="daily-blog-header">
                        <div className="daily-blog-header-top">
                            <div className="daily-blog-meta">
                                <Icon icon="mdi:newspaper-variant-outline" className="daily-blog-meta-icon" aria-hidden="true" />
                                <span className="daily-blog-eyebrow">Daily market blog</span>
                                <span className="daily-blog-date">{post.dayLabel}</span>
                            </div>
                            <ContentShareMenu
                                title={`NeuraTrader market blog: ${post.title}`}
                                text={shareText}
                                shareHash="daily-market-blog"
                                label="Share"
                            />
                        </div>
                        <p className="daily-blog-byline">
                            {post.author} · {post.readMinutes} min read
                        </p>
                    </header>

                    <h2 className="daily-blog-title">{post.title}</h2>
                    <p className="daily-blog-excerpt">{post.excerpt}</p>

                    {post.markets.length > 0 && (
                        <div className="daily-blog-markets">
                            {post.markets.map((market) => (
                                <div key={market.symbol} className="daily-blog-market-chip">
                                    <span className="daily-blog-market-symbol">{market.displaySymbol}</span>
                                    <span className="daily-blog-market-price">{market.priceLabel}</span>
                                    <span className={`daily-blog-market-change ${market.direction === 'up' ? 'is-up' : 'is-down'}`}>
                                        {market.changeLabel}
                                    </span>
                                </div>
                            ))}
                        </div>
                    )}

                    <div className="daily-blog-body">
                        {post.paragraphs.map((paragraph, index) => (
                            <p key={index} className="daily-blog-paragraph">
                                {paragraph}
                            </p>
                        ))}
                    </div>

                    <footer className="daily-blog-footer">
                        <div className="daily-blog-tags">
                            {post.tags.map((tag) => (
                                <span key={tag} className="daily-blog-tag">
                                    {tag}
                                </span>
                            ))}
                        </div>
                        <p className="daily-blog-disclaimer">
                            Market data from public exchange tickers. Not financial advice.
                        </p>
                    </footer>
                </div>
            </article>
        </section>
    );
}

export default DailyBlogPost;